import React from "react";
import "../css/Workout.css";

const Workout = () => {
  return (
    <div className="workout5">

      {/* ======================================================
          SECTION 1 — EARTH GRADIENT HERO
      ======================================================= */}
      <section className="wk-hero">
        <div className="wk-hero-inner">
          <h1>Workouts That Grow With You</h1>
          <p>
            Slow, steady, natural progression.  
            EARTHFIT training evolves with your breath, balance, and rhythm.
          </p>
        </div>
      </section>



      {/* ======================================================
          SECTION 2 — MOVEMENT PATH (3 Natural Steps)
      ======================================================= */}
      <section className="wk-path">
        <h2>The Natural Movement Path</h2>

        <div className="path-grid">

          <div className="path-step">
            <img src="https://images.pexels.com/photos/3823063/pexels-photo-3823063.jpeg" alt="warm up" />
            <h3>1. Warm & Ground</h3>
            <p>Begin with breath-led motion to awaken awareness.</p>
          </div>

          <div className="path-step">
            <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" alt="train" />
            <h3>2. Train With Purpose</h3>
            <p>Functional strength, mindful pacing, deep control.</p>
          </div>

          <div className="path-step">
            <img src="https://images.pexels.com/photos/4327033/pexels-photo-4327033.jpeg" alt="restore" />
            <h3>3. Restore & Expand</h3>
            <p>Mobility flow to re-center the body after effort.</p>
          </div>

        </div>
      </section>



      {/* ======================================================
          SECTION 3 — EARTH ROUTINE CARDS
      ======================================================= */}
      <section className="wk-routines">
        <h2>Choose Your Practice</h2>

        <div className="routine-grid">

          <div className="routine-card">
            <h3>Grounded Strength</h3>
            <p>Slow tempo lifts + core stability + posture resets.</p>
          </div>

          <div className="routine-card">
            <h3>Mobility Flow</h3>
            <p>Fluid joints, gentle stretching, natural range expansion.</p>
          </div>

          <div className="routine-card">
            <h3>Breath Conditioning</h3>
            <p>Low-impact conditioning designed around breathing cycles.</p>
          </div>

          <div className="routine-card">
            <h3>Natural Balance</h3>
            <p>Stability, footwork, and posture harmonization.</p>
          </div>

        </div>
      </section>



      {/* ======================================================
          SECTION 4 — WEEKLY PLAN (Simple Earth Blocks)
      ====================================================== */}
      <section className="wk-weekly">
        <h2>Your Weekly Flow</h2>
      
        <div className="wk-week-grid">
      
          <div className="wk-week-box">
            <h3>Day 1 — Strength Roots</h3>
            <p>Core stability and grounded lower-body training.</p>
          </div>
      
          <div className="wk-week-box">
            <h3>Day 3 — Flow Mobility</h3>
            <p>Breath-guided stretching and joint restoration.</p>
          </div>
      
          <div className="wk-week-box">
            <h3>Day 5 — Natural Conditioning</h3>
            <p>Low-impact conditioning with controlled pacing.</p>
          </div>
      
          <div className="wk-week-box">
            <h3>Day 7 — Recovery & Reset</h3>
            <p>Restorative mobility and mindful breath reset.</p>
          </div>
      
        </div>
      </section>



      {/* ======================================================
          SECTION 5 — NATURE PANEL
      ======================================================= */}
      <section className="wk-nature">
        <blockquote>
          “Move like nature — slow, intentional, evolving.”
        </blockquote>
      </section>



      {/* ======================================================
          SECTION 6 — EARTH OUTRO
      ======================================================= */}
      <section className="wk-outro">
        <h2>Train With Calm Strength</h2>
        <p>Feel grounded, present, and naturally powerful.</p>

        <div className="out-soil o1"></div>
        <div className="out-soil o2"></div>
      </section>

    </div>
  );
};

export default Workout;
